import * as React from 'react'

import * as Sentry from '@sentry/nextjs'
import { detect } from 'detect-browser'

import FeatureFlipperProvider from '../reason/featureFlipper/FeatureFlipperProvider'
import { providerJs as SystemMessagesProvider } from '../reason/systemMessages/SystemMessages.bs'

import OldBrowserWarning from '../modules/BrowserWarning/components/BrowserWarningPage.bs'

function isSupportedBrowser() {
  const browser = detect()
  const supportedBrowsers = {
    safari: 14.1,
    edge: 88,
    chrome: 88,
    firefox: 82,
    ios: 14.0,
    crios: 88,
    fxios: 82,
    'ios-webview': 605,
    'edge-chromium': 88.0,
    'edge-ios': 88.0,
    'chromium-webview': 88,
    samsung: 15.0,
    opera: 80,
  }

  if (
    typeof window !== 'undefined' &&
    (!browser ||
      !supportedBrowsers[browser.name] ||
      parseFloat(browser.version) < supportedBrowsers[browser.name])
  ) {
    Sentry.withScope(scope => {
      scope.setExtra('detected_browser', JSON.stringify(browser))
      const name = browser && browser.name ? browser.name : 'unknown'
      const version = browser && browser.version ? browser.version : 'unknown'
      Sentry.captureMessage(`The browser ${name} at version ${version} was forbidden`, 'info')
    })
    return false
  }
  return true
}

export function App(props) {
  return (
    <FeatureFlipperProvider>
      <SystemMessagesProvider>
        {isSupportedBrowser() ? props.children : <OldBrowserWarning />}
      </SystemMessagesProvider>
    </FeatureFlipperProvider>
  )
}

export default App
